"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Grid_1 = __importDefault(require("@material-ui/core/Grid"));
var core_1 = require("@material-ui/core");
var Button_1 = __importDefault(require("@material-ui/core/Button"));
var ArrowBack_1 = __importDefault(require("@material-ui/icons/ArrowBack"));
var Hidden_1 = __importDefault(require("@material-ui/core/Hidden"));
var styles_1 = require("@material-ui/core/styles");
var useStyles = (0, styles_1.makeStyles)(function (theme) {
    var _a, _b;
    return (0, styles_1.createStyles)({
        root: {
            flexGrow: 1,
        },
        left: {
            float: 'left',
            color: 'gray',
        },
        labelButton: {
            marginRight: '10px',
            color: 'gray'
        },
        labelButton2: {
            color: 'gray',
            padding: 0,
        },
        title: (_a = {
                marginLeft: -60
            },
            _a[theme.breakpoints.down('xs')] = {
                fontSize: "0.7em"
            },
            _a),
        title2: (_b = {
                marginLeft: -100
            },
            _b[theme.breakpoints.down('xs')] = {
                fontSize: "0.7em"
            },
            _b),
        paper: {
            backgroundColor: '#fff',
            padding: "10px",
        },
        nonedisplay: {
            display: "none"
        },
        showdisplay: {
            padding: "5px",
        }
    });
});
function Page(props) {
    var classes = useStyles({});
    var displayClass;
    (props.pagetitle == undefined || props.pagetitle.length == 0) ?
        displayClass = classes.nonedisplay : displayClass = classes.showdisplay;
    return (React.createElement("div", { className: classes.root },
        React.createElement(Grid_1.default, { item: true, xs: 12 },
            React.createElement("div", { className: classes.paper },
                !props.hideBtn ?
                    React.createElement(Hidden_1.default, { only: ['sm', 'xs'] },
                        React.createElement(Button_1.default, { className: classes.left, onClick: props.history.goBack, disabled: props.disabled || false },
                            React.createElement(ArrowBack_1.default, { className: classes.labelButton }),
                            "Voltar")) : null,
                React.createElement(Hidden_1.default, { only: ['md', 'lg', 'xl'] },
                    React.createElement(Button_1.default, { className: classes.left, onClick: props.history.goBack, disabled: props.disabled || false },
                        React.createElement(ArrowBack_1.default, { className: classes.labelButton2 }))),
                React.createElement(core_1.Typography, { variant: "h6", align: 'center', noWrap: true, color: "textSecondary", className: displayClass },
                    React.createElement(Hidden_1.default, { only: ['sm', 'xs'] },
                        React.createElement("span", { className: classes.title2 }, props.pagetitle)),
                    React.createElement(Hidden_1.default, { only: ['md', 'lg', 'xl'] },
                        React.createElement("span", { className: classes.title }, props.pagetitle)))),
            React.createElement("div", { className: classes.paper }, props.children))));
}
exports.default = Page;
//# sourceMappingURL=Page.js.map